import * as React from "react";

const Button = React.forwardRef(({ 
  className = "", 
  variant = "default", 
  size = "default", 
  children, 
  ...props 
}, ref) => {
  const baseClasses = `
    inline-flex items-center justify-center gap-2 whitespace-nowrap 
    font-bold text-sm transition-all duration-150 ease-out
    disabled:pointer-events-none disabled:opacity-50
    border-2 border-black
    active:translate-x-1 active:translate-y-1 active:shadow-none
  `;

  const variants = {
    default: `
      bg-primary text-primary-foreground 
      shadow-md hover:shadow-lg
      hover:-translate-x-1 hover:-translate-y-1
    `,
    outline: `
      bg-background text-foreground 
      shadow-md hover:shadow-lg
      hover:-translate-x-1 hover:-translate-y-1
    `,
    secondary: `
      bg-secondary text-secondary-foreground 
      shadow-md hover:shadow-lg
      hover:-translate-x-1 hover:-translate-y-1
    `,
    accent: `
      bg-accent text-accent-foreground 
      shadow-md hover:shadow-lg
      hover:-translate-x-1 hover:-translate-y-1
    `,
    destructive: `
      bg-destructive text-white 
      shadow-md hover:shadow-lg
      hover:-translate-x-1 hover:-translate-y-1
    `,
  };

  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 px-3 text-xs",
    lg: "h-11 px-8",
    icon: "h-10 w-10",
  };

  const combinedClassName = `
    ${baseClasses} 
    ${variants[variant]} 
    ${sizes[size]} 
    ${className}
  `.replace(/\s+/g, ' ').trim();

  return (
    <button
      className={combinedClassName}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };